import { render, staticRenderFns } from "./indextree.vue?vue&type=template&id=6670436e&scoped=true&"
import script from "./indextree.vue?vue&type=script&lang=js&"
export * from "./indextree.vue?vue&type=script&lang=js&"
import style0 from "./indextree.vue?vue&type=style&index=0&id=6670436e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670436e",
  null
  
)

export default component.exports